"use client"

import { useTheme } from "next-themes"
import Image from "next/image"
import * as React from "react"

import { ShineBorder } from "@tailark/core/magicui/shine-border"
import { Card, CardContent } from "@tailark/core/ui/card"

export function HeroProductScreenshot() {
    const { theme, systemTheme } = useTheme()
    const [mounted, setMounted] = React.useState(false)

    React.useEffect(() => {
        setMounted(true)
    }, [])

    const gradientColor = React.useMemo(() => {
        if (!mounted) return "#262626"
        const current = theme === "system" ? systemTheme : theme
        return current === "dark" ? "#262626" : "#D9D9D955"
    }, [mounted, theme, systemTheme])

    return (
        <Card className="w-full max-w-6xl mx-auto border-none rounded-2xl !bg-card/75 !p-4  shadow-none">
            <CardContent className="relative !p-0">
                <ShineBorder shineColor={["#A07CFE", "#FE8FB5", "#FFBE7B"]} className="rounded-xl" duration={25} borderWidth={1} />

                <Image
                    className="bg-background aspect-15/8 relative hidden rounded-xl object-contain dark:block"
                    src="/image.png"
                    alt="app screen"
                    width={2700}
                    height={1440}
                />
                <Image
                    className="border-border/25 relative z-2 aspect-15/8 rounded-xl border object-contain dark:hidden object-top"
                    src="/image.png"
                    alt="app screen"
                    width={2700}
                    height={1440}
                />

            </CardContent>
        </Card>
    )
}
